<template>
  <div v-if="order.id">
    <div class="flex flex-wrap justify-between mb-4">
      <div class="flex-inline">
        <vs-button
          class="mr-3"
          icon-pack="feather"
          color="danger"
          icon="icon icon-x-circle"
          @click="refundOrderConfirm = true"
          v-if="canRefund"
          >Cancelar</vs-button
        >
        <vs-button
          class="mr-3"
          icon-pack="feather"
          color="success"
          icon="icon icon-dollar-sign"
          @click="approveOrderConfirm = true"
          v-if="order.status == 'Aguardando Pagamento' && order.user_id > 0"
          >Marcar como Paga</vs-button
        >

        <strong v-if="order.user_id <= 0">Venda sem cliente, não será possível marcar como paga.</strong>
      </div>
      <div class="flex align-items-end">
        <vs-button class="mr-4" icon-pack="feather" icon="icon icon-arrow-left" @click="back">Voltar</vs-button>
        <vs-button icon-pack="feather" icon="icon icon-file" @click="print">Imprimir</vs-button>
      </div>
    </div>

    <div class="flex">
      <div id="invoice-page" class="w-9/12 mb-base mr-4">
        <vx-card id="invoice-container">
          <!-- INVOICE METADATA -->
          <div class="vx-row leading-loose p-base">
            <div class="vx-col w-1/2 mt-base">
              <img :src="`/assets/images/logo/logo_${appFilename}.png`" alt="" />
            </div>
            <div class="vx-col w-1/2 text-right">
              <h1
                :class="{
                  'text-success': order.status == 'Pago',
                  'text-warning': order.status == 'Aguardando Pagamento',
                  'text-danger': order.status.indexOf('Cancelada') > -1,
                }"
              >
                {{ order.status }}
              </h1>

              <div class="invoice__invoice-detail mt-6">
                <h3>{{ order.number }}</h3>
                <p>{{ order.created_at | formatDateTime }}</p>
              </div>
            </div>
            <div class="vx-col w-1/2 mt-12">
              <div class="invoice__recipient-info my-4">
                <p v-if="order.user">{{ order.user.name }}</p>
                <p v-if="order.user">
                  <router-link :to="{ name: 'cliente-detalhes', params: { id: order.user.id } }">{{
                    order.user.email
                  }}</router-link>
                </p>
                <p v-if="order.user">{{ order.user.cpfcnpj }}</p>
                <p v-if="order.user">
                  {{ order.user.address_street }}
                  {{ order.user.address_number }}
                </p>
                <p v-if="order.user">{{ order.user.address_postcode }}</p>
                <p v-if="order.user">{{ order.user.address_city }}</p>
                <p v-if="order.user">{{ order.user.address_state }}</p>
              </div>
            </div>
            <div class="vx-col w-1/2 mt-base text-right mt-12">
              <div class="invoice__company-info my-4">
                <p>{{ order.payment_method }}</p>
                <p>
                  <a
                    :href="
                      'https://www.wtsoftware.com.br/checkout/complete?orderId=' +
                      order.id +
                      '&orderNumber=' +
                      order.number
                    "
                    target="_blank"
                    >Ver Venda no Site</a
                  >
                </p>
                <p v-if="order.payment_method == 'Cartão de Crédito'">{{ order.installments }}x</p>
              </div>
            </div>
          </div>

          <!-- INVOICE CONTENT -->
          <div class="p-base">
            <vs-table :stripe="true" :data="order.plans">
              <!-- HEADER -->
              <template slot="thead">
                <vs-th class="pointer-events-none">PRODUTO</vs-th>
                <vs-th class="pointer-events-none text-center">
                  <span>ASSINATURA</span>
                </vs-th>
                <vs-th class="pointer-events-none text-right">
                  <span>QUANTIDADE</span>
                </vs-th>
                <vs-th class="pointer-events-none text-right">
                  <span>PREÇO (INICIAL)</span>
                </vs-th>
                <vs-th class="pointer-events-none text-right">
                  <span>PREÇO (RECORRENTE)</span>
                </vs-th>
              </template>

              <!-- DATA -->
              <template>
                <vs-tr v-for="plan in order.plans" :key="plan.id">
                  <vs-td>{{ plan.name }}</vs-td>
                  <vs-td class="text-center">{{ plan.recurring }}</vs-td>
                  <vs-td class="text-right">{{ plan.pivot.plan_quantity }}</vs-td>
                  <vs-td class="text-right" v-if="plan.pivot.plan_setup_fee == 0">{{
                    plan.pivot.plan_fixed_price | money(order.currency_code)
                  }}</vs-td>
                  <vs-td class="text-right" v-if="plan.pivot.plan_setup_fee == 0">{{ 0 | money(order.currency_code) }}</vs-td>
                  <vs-td class="text-right" v-if="plan.pivot.plan_setup_fee > 0">{{
                    plan.pivot.plan_setup_fee | money(order.currency_code)
                  }}</vs-td>
                  <vs-td class="text-right" v-if="plan.pivot.plan_setup_fee > 0">{{
                    plan.pivot.plan_fixed_price | money(order.currency_code)
                  }}</vs-td>
                </vs-tr>
              </template>
            </vs-table>

            <!-- INVOICE SUMMARY TABLE -->
            <div class="w-6/12 ml-auto mt-4">
              <vs-table :stripe="true" :data="order.plans">
                <vs-tr>
                  <vs-th class="pointer-events-none">SUBTOTAL</vs-th>
                  <vs-td>{{ order.subtotal | money(order.currency_code) }}</vs-td>
                </vs-tr>
                <vs-tr v-if="order.discount > 0">
                  <vs-th class="pointer-events-none">DESCONTOS/CUPOM</vs-th>
                  <vs-td class="text-warning">{{ order.discount | money(order.currency_code) }}</vs-td>
                </vs-tr>
                <vs-tr v-if="order.fee > 0">
                  <vs-th class="pointer-events-none">TAXAS</vs-th>
                  <vs-td class="text-warning">{{ order.fee | money(order.currency_code) }}</vs-td>
                </vs-tr>
                <vs-tr>
                  <vs-th class="pointer-events-none">TOTAL</vs-th>
                  <vs-td class="text-success">{{ order.total | money(order.currency_code) }}</vs-td>
                </vs-tr>
                <vs-tr v-if="order.refund > 0">
                  <vs-th class="pointer-events-none">DEVOLUÇÕES</vs-th>
                  <vs-td class="text-danger">{{ order.refund | money(order.currency_code) }}</vs-td>
                </vs-tr>
              </vs-table>
            </div>

            <vs-table :stripe="true" :data="order.payments" class="mt-4" v-if="order.payments.length">
              <template slot="header">
                <h3 class="p-2">Pagamentos</h3>
              </template>

              <!-- HEADER -->
              <template slot="thead">
                <vs-th class="pointer-events-none">DATA</vs-th>
                <vs-th class="pointer-events-none">ID</vs-th>
              </template>

              <!-- DATA -->
              <template>
                <vs-tr v-for="payment in order.payments" :key="payment.id">
                  <vs-td>{{ payment.created_at | formatDateTime }}</vs-td>
                  <vs-td>{{ payment.transaction_id || '-' }}</vs-td>
                </vs-tr>
              </template>
            </vs-table>

            <vs-table :stripe="true" :data="order.refunds" class="mt-4" v-if="order.refunds.length">
              <template slot="header">
                <h3 class="p-2">Devoluções</h3>
              </template>

              <!-- HEADER -->
              <template slot="thead">
                <vs-th class="pointer-events-none">DATA</vs-th>
                <vs-th class="pointer-events-none">USUÁRIO</vs-th>
                <vs-th class="pointer-events-none">VIA</vs-th>
                <vs-th class="pointer-events-none">ID</vs-th>
                <vs-th class="pointer-events-none">VALOR</vs-th>
              </template>

              <!-- DATA -->
              <template>
                <vs-tr v-for="refund in order.refunds" :key="refund.id">
                  <vs-td>{{ refund.created_at | formatDateTime }}</vs-td>
                  <vs-td v-if="refund.admin">{{ refund.admin.name }}</vs-td>
                  <vs-td v-else>Sistema</vs-td>
                  <vs-td>{{ refund.refund_method }}</vs-td>
                  <vs-td>{{ refund.transaction_id || '-' }}</vs-td>
                  <vs-td>{{ refund.amount | money(order.currency_code) }}</vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>

          <!-- INVOICE FOOTER -->
          <div class="invoice__footer text-right p-base">
            <p class="mb-4">WTSOFTWARE LTDA ME</p>
            <p>
              <span class="mr-8">
                CNPJ:
                <span class="font-semibold">10.176.559/0001-20</span>
              </span>
              <span>
                TELEFONE:
                <span class="font-semibold">11 3042-4808</span>
              </span>
            </p>
          </div>

          <small><em>
          Cliente {{ order.user.name }} por meio do endereço IP {{ order.ip_address || order.user.ip_address }}, acessou o site e efetuou a
          compra no dia {{ order.created_at | formatDate }} às {{ order.created_at | formatTime }} (horário de Brasília), feito isso acessou o
          painel de controle para liberar a licença no dia {{ (order.licences[0] && order.licences[0].date_used || order.created_at) | formatDate }} usando a conta que foi
          criada, seu último acesso ocorreu no dia {{ order.user.ultimo_login | formatDate }} às
          {{ order.user.ultimo_login | formatTime }}. O cliente possui o<span v-if="order.user.mobiles.length > 1"
            >s</span
          >
          seguinte<span v-if="order.user.mobiles.length > 1">s</span> dispositivo<span
            v-if="order.user.mobiles.length > 1"
            >s</span
          >
          em sua conta:
          <span v-for="(mobile, index) in order.user.mobiles" :key="mobile.id"
            >{{ mobile.device }} e o último envio dos dados foi em {{ mobile.updated_at | formatDateTime
            }}<span v-if="index === order.user.mobiles.length - 1">.</span><span v-else>, </span></span
          >
          </em>
          </small>
        </vx-card>
      </div>
      <div class="w-3/12">
        <vx-card class="mb-4" v-if="!order.history.length">Nenhum histórico.</vx-card>

        <vx-card class="mb-4" v-for="history in order.history" :key="history.id">
          <strong>
            {{ history.created_at | formatDateTime }} -
            <span v-if="history.admin">{{ history.admin.name }}</span>
            <span v-else>Sistema</span>
          </strong>
          <div class="whitespace-pre-wrap">{{ history.comment }}</div>
        </vx-card>
      </div>
    </div>

    <vs-prompt
      title="Cancelar"
      color="danger"
      @accept="refundOrder"
      :active.sync="refundOrderConfirm"
      accept-text="Continuar"
      cancel-text="Fechar"
    >
      <div>
        <p class="mb-2">
          O valor máximo à devolver é
          <strong>{{ maximumRefund | money(order.currency_code) }}</strong
          >.
        </p>
        <vs-input class="w-100" v-model="refund.amount" rows="4" placeholder="0,00" />
        <small class="text-grey mb-4 d-block">
          <em>Use vírgula para separar os centavos ex. 123,45.</em>
        </small>

        <vs-textarea
          class="w-100 mt-2"
          v-model="refund.comment"
          rows="4"
          placeholder="Motivo da devolução (obrigatório)"
        ></vs-textarea>

        <vs-textarea
          v-if="order.payment_method == 'Boleto' || order.payment_method == 'Transferência'"
          class="w-100 mt-2"
          v-model="refund.bank_details"
          rows="4"
          placeholder="Dados bancários para devolução (obrigatório)"
        ></vs-textarea>
      </div>
    </vs-prompt>

    <vs-prompt
      color="success"
      @accept="approveOrder"
      :active.sync="approveOrderConfirm"
      accept-text="Continuar"
      cancel-text="Fechar"
      title="Marcar como Paga"
    >
      Este processo irá:
      <br />
      <ul>
        <li>- Gerar licença para os itens comprados.</li>
        <li>- Enviar um e-mail para o cliente.</li>
        <li>- Atualizar a data da venda para o dia/hora de hoje.</li>
      </ul>
      <br />
    </vs-prompt>
  </div>
</template>

<script>
export default {
  data() {
    return {
      order: {
        user: {},
        plans: [],
        history: [],
        refunds: [],
        payments: [],
      },
      refundOrderConfirm: false,
      approveOrderConfirm: false,
      refund: {
        amount: '',
        comment: '',
      },
      appFilename: process.env.VUE_APP_FILENAME,
    };
  },
  computed: {
    canRefund() {
      if (!this.order.total) return;

      return (
        parseFloat(this.order.total) + parseFloat(this.order.fee) > parseFloat(this.order.refund) &&
        (this.order.status === 'Pago' || this.order.status.indexOf('Cancelada') > -1)
      );
    },
    maximumRefund() {
      if (!this.order.total) return 0;

      return this.order.total + this.order.fee - this.order.refund;
    },
  },
  mounted() {
    this.$emit('setAppClasses', 'invoice-page');

    this.$api.get(`/api/v1/backend/order/${this.$route.params.id}`).then((response) => {
      this.order = response.data;
    });
  },
  methods: {
    print() {
      window.print();
    },
    back() {
      window.history.back();
    },
    approveOrder() {
      this.$vs.loading();

      this.$api
        .patch(`/api/v1/backend/order/${this.$route.params.id}/paid`)
        .then((response) => {
          this.$vs.loading.close();
          this.order = response.data;
        })
        .catch((err) => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: 'Erro',
            text: err.response.data.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger',
          });
        });
    },
    refundOrder() {
      this.$vs.loading();

      this.$api
        .patch(`/api/v1/backend/order/${this.$route.params.id}/refund`, this.refund)
        .then((response) => {
          this.$vs.loading.close();
          this.order = response.data;

          this.refund = {
            amount: '',
            comment: '',
          };
        })
        .catch((err) => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: 'Erro',
            text: err.response.data.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger',
          });
        });
    },
  },
};
</script>

<style lang="scss">
@media print {
  .invoice-page {
    * {
      visibility: hidden;
    }

    #content-area {
      margin: 0 !important;
    }

    .vs-con-table {
      .vs-con-tbody {
        overflow: hidden !important;
      }
    }

    #invoice-container,
    #invoice-container * {
      visibility: visible;
    }
    #invoice-container {
      position: absolute;
      left: 0;
      top: 0;
      box-shadow: none;
    }
  }
}

@page {
  size: auto;
}

.vs-con-table {
  .vs-table--thead {
    th {
      .vs-table-text {
        display: inline-block;
      }
    }
  }
}
</style>
